var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { TraitConditionSideEvaluator } from './TraitConditionSideEvaluator';
import { deserialize } from '../../../utils/serializr/serializr';
export class TraitConditionRightEvaluator extends TraitConditionSideEvaluator {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get traitCondition() {
        return this.parentCondition.condition_right;
    }
    set traitCondition(tc) {
        this.parentCondition.condition_right = tc;
    }
    setTraitCondition(tc) {
        if (!this.parent.traitCondition)
            return;
        this.parent.traitCondition.condition_right = tc;
    }
    static fromSerialized(ser = {}) {
        return deserialize(TraitConditionRightEvaluator, ser);
    }
}
__decorate([
    action.bound
], TraitConditionRightEvaluator.prototype, "setTraitCondition", null);
